import { useTranslation } from '@dukanti/shared';
import { SkeletonBar } from '@/features/products/components/skeleton-bar';

export function CategoriesListSkeleton() {
  const { t } = useTranslation();

  return (
    <div
      role="status"
      aria-busy="true"
      data-testid="categories-list-skeleton"
      className="border-border bg-card shadow-admin-card rounded-lg border p-4"
    >
      <span className="sr-only">{t('admin.categories.loading')}</span>
      {Array.from({ length: 4 }).map((_, index) => (
        <div
          key={index}
          className="border-border flex items-center gap-3 border-b py-4 last:border-b-0"
        >
          <SkeletonBar className="size-14 rounded-lg" />
          <div className="min-w-0 flex-1">
            <SkeletonBar className="mb-2 h-5 w-40" />
            <SkeletonBar className="h-4 w-24" />
          </div>
          <SkeletonBar className="h-9 w-28 rounded-md" />
        </div>
      ))}
    </div>
  );
}
